module.exports = __webpack_public_path__ + "static/Resolvers-0b828eb845449114cc25ebbab13788d5.png";